import * as HLF from "html-living-framework";
import {Application} from "../Application";
import {Anchor} from "../core/Anchor";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {ButtonPlay} from "../gameobjects/ButtonPlay";
import {Focusables} from "../gameobjects/Focusables";
import {StartScreenLayout_main} from "../layout/StartScreenLayout";
import {AnalyticsManager} from "../managers/AnalyticsManager";

export class StartScreen extends HLF.LoadScreen {

    public static readonly NAME = "StartScreen";

    public readonly bg = this.addChild(new Sprite("splash", Anchor.middleCenter));
    public readonly main = this.addChild(new Container());
    public readonly loader = this.main.addChild(new Sprite());
    public readonly buttonPlay = this.main.addChild(new ButtonPlay(() => {
        this.onClickPlay();
    }));

    private _onLoaded?: Callback;
    private _isAimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        StartScreenLayout_main.call(this);
        this.main.scale.set(0.5);
        this.buttonPlay.visible = false;

        this.loader.tweenTo(1, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAimatedIn = true;
                this.showPlayButton();
            });
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.height = this._size.y;
        this.bg.width = this.bg.height * this.bg.texture.width / this.bg.texture.height;
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        this.showPlayButton();
    }

    private showPlayButton() {
        if (this._isAimatedIn && this._onLoaded) {
            AnalyticsManager.event("Story Creator", "startGame");
            this.loader.moveYTo(this._size.y + this.loader.height, 0.4, Ease.sineIn, () => {
                this.loader.visible = false;
                this.buttonPlay.visible = true;
                this.buttonPlay.moveYFrom(this._size.y + this.buttonPlay.height, 0.6, Ease.backOut);
                this.bg.interactive = true;
                this.bg.on("pointertap", () => {
                    this.onClickPlay();
                });
                Focusables.add(this.buttonPlay);
            });
        }
    }

    private onClickPlay() {
        this.interactiveChildren = false;
        Focusables.enabled = false;
        AnalyticsManager.event("Story Creator", "Launch",
            Application.instance.saveManager.readBool("story-creator-visited") ? "false" : "true");
        Application.instance.saveManager.storeBool("story-creator-visited", true);
        if (this._onLoaded) {
            this._onLoaded();
        }
    }
}
